import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { PslfFormExtension as PslfFormModel } from 'tio-data/data/resources/pslf-form.ext';
import type { Store } from '@warp-drive/core';

type SuccessRouteParams = {
  form_id: string;
  pastPeriodIds?: string;
};

export default class AuthenticatedPslfFormSuccessRoute extends Route {
  @service declare store: Store;

  queryParams = {
    pastPeriodIds: {
      refreshModel: true,
    },
  };

  async model(params: SuccessRouteParams) {
    // WarpDrive builder read (Phase 2.4) — replaces store.findRecord.
    const { content: primaryContent } = (await this.store.request(
      findRecord<PslfFormModel>('pslf-form', params.form_id, {
        include: 'attachments',
      })
    )) as { content: { data: PslfFormModel } };
    const primaryForm = primaryContent.data;

    const pastPeriodIds = params.pastPeriodIds
      ? params.pastPeriodIds
          .split(',')
          .map((id) => id.trim())
          .filter((id) => id.length > 0)
      : [];

    const pastPeriodForms = await Promise.all(
      pastPeriodIds.map(async (id) => {
        // WarpDrive builder read (Phase 2.4) — replaces store.findRecord.
        const { content } = (await this.store.request(
          findRecord<PslfFormModel>('pslf-form', id, { include: 'attachments' })
        )) as { content: { data: PslfFormModel } };
        return content.data;
      })
    );

    return {
      primaryForm,
      pastPeriodForms,
      allForms: [primaryForm, ...pastPeriodForms],
    };
  }
}
